import { getCookie } from "@insite/client-framework/Common/Cookies";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import logger from "@insite/client-framework/Logger";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import setSignInOverlayIsOpen from "@insite/client-framework/Store/Components/SignInOverlay/Handlers/SetSignInOverlayIsOpen";
import { getCurrentUserIsGuest, getIsPunchOutSession, getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import cancelPunchOut from "@insite/client-framework/Store/Context/Handlers/CancelPunchOut";
import setShowInventory from "@insite/client-framework/Store/Context/Handlers/SetShowInventory";
import setShowPricing from "@insite/client-framework/Store/Context/Handlers/SetShowPricing";
import signOut from "@insite/client-framework/Store/Context/Handlers/SignOut";
import { getCurrentPage, getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import setIsReorderConfirmationModalOpen from "@insite/client-framework/Store/Pages/VmiBins/Handlers/SetIsReorderConfirmationModalOpen";
import setNextAction from "@insite/client-framework/Store/Pages/VmiBins/Handlers/SetNextAction";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { useMergeStyles } from "@insite/content-library/additionalStyles";
import { NavigationModeCookieName } from "@insite/content-library/Components/NavigationModeMenu";
import Clickable, { ClickablePresentationProps } from "@insite/mobius/Clickable";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Icon, { IconPresentationProps } from "@insite/mobius/Icon/Icon";
import Eye from "@insite/mobius/Icons/Eye";
import EyeOff from "@insite/mobius/Icons/EyeOff";
import User from "@insite/mobius/Icons/User";
// import Menu, { MappedLink } from "@insite/mobius/Menu";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography/Typography";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { navigationInteraction } from "@WhiteCap/Common/Utillities/CustomTracking";
import Menu, { MappedLink } from "@WhiteCap/MobiusOverrides/Menu";
import cloneDeep from "lodash/cloneDeep";
import React, { useEffect } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css, ThemeProps, withTheme } from "styled-components";

const enum fields {
    visibilityState = "visibilityState",
    icon = "icon",
    includeAccountMenu = "includeAccountMenu",
    showPricingToggle = "showPricingToggle",
    showInventoryToggle = "showInventoryToggle",
}

const mapStateToProps = (state: ApplicationState) => {
    const session = getSession(state);
    return {
        isSignInPage: getCurrentPage(state).type === "SignInPage",
        userName: state.context.session.userName,
        myAccountPageLink: getPageLinkByPageType(state, "MyAccountPage"),
        signInUrl: getPageLinkByPageType(state, "SignInPage")?.url,
        createAccountUrl: getPageLinkByPageType(state, "CreateAccountPage")?.url,
        currentUserIsGuest: getCurrentUserIsGuest(state),
        isPunchOutSession: getIsPunchOutSession(state),
        currentLocation: getLocation(state),
        displayChangeCustomerLink: state.context.session?.displayChangeCustomerLink || false,
        displayPricingAndInventory: state.context.session?.displayPricingAndInventory || false,
        showInventory: state.context.showInventory,
        showPricing: state.context.showPricing,
        isReorderConfirmationModalOpen: state.pages.vmiBins.isReorderConfirmationModalOpen,
    hasChangeLastQty:
        state.pages.vmiBins.selectVmiBinsChangedQty &&
        Object.keys(state.pages.vmiBins.selectVmiBinsChangedQty).length > 0,
        customSession:session,
        orderConfirmationPageUrl: getPageLinkByPageType(state, "OrderConfirmationPage")?.url,
        onePageCheckoutConfirmationPageUrl: getPageLinkByPageType(state, "OnePageCheckoutConfirmationPage")?.url,
    };
};


const mapDispatchToProps = {
    signOut,
    cancelPunchOut,
    setSignInOverlayIsOpen,
    setShowInventory,
    setShowPricing,
    setIsReorderConfirmationModalOpen,
    setNextAction,
};

export interface HeaderSignInStyles {
    signOutWrapper?: InjectableCss;
    titleClickable?: ClickablePresentationProps;
    titleIcon?: IconPresentationProps;
    titleTypography?: TypographyPresentationProps;
    signInTitleTypography?: TypographyPresentationProps;
    signOutClickable?: ClickablePresentationProps;
    modalSignIn?: InjectableCss;
    signInButtonContainer?: InjectableCss;
    signInButton?: InjectableCss;
    middleBorder?: InjectableCss;
    createAccountContainer?: InjectableCss;
    createAccountText?: InjectableCss;
    createAccount?: InjectableCss;
    createAccountButton?: InjectableCss;
}

export const headerSignInStyles: HeaderSignInStyles = {
    signOutWrapper: {
        css: css`
            display: inline-flex;
            padding: 6px 0;
            nav[aria-labelledby^="accountMenu"] {
                ul {
                    right: auto;
                    /* @media screen and (max-width: 1366px) {
                        right: 0;
                    } */
                }
            }
        `,
    },
    titleClickable: {
        css: css`
            margin-left: 0px;
        `,
    },
    titleIcon: {
        size: 22,
        css: css`
            color: white;
            margin-left:16px;
            margin-right:10px;
        `,
    },
    titleTypography: {
        css: css`
            max-width: 93px;
            color: #fff;
        `,
        ellipsis: true,
        transform: "capitalize",
    },
    signInTitleTypography: {
        css: css`
            max-width: 93px;
            color: #fc3;
        `,
        ellipsis: true,
        transform: "capitalize",
    },
    signOutClickable: {
        css: css`
            width: 100%;
            min-height: 42px;
            padding: 10px 15px 10px 20px;
            color: #0f0f0f;
            font-size: 15px;
            text-transform: capitalize;
            &:hover {
                background: #cccccc;
            }
        `,
    },
    modalSignIn: {
        css: css`
            width: 300px;
            height: 235px;
            position: absolute;
            right: -80px;
            top: 50px;
            background-color: #ccc;
            box-shadow: 0 4px 25px 2px rgba(0, 0, 0, 0.17);
            z-index: 101;
            display: flex;
            flex-direction: column;
            row-gap: 10px;
            justify-content: center;
            padding: 20px;
            align-items: center;
            ::before {
                border-color: transparent transparent #ccc;
                border-style: solid;
                border-width: 0 1rem 1.2rem;
                content: "";
                height: 0;
                left: 0;
                margin: -1rem auto 0;
                position: absolute;
                right: 0;
                top: 0;
                width: 0;
            }
        `,
    },
    signInButtonContainer: {
        css: css`
            display: flex;
            justify-content: center;
            margin: 0px auto;
            max-width: 250px;
            margin-bottom: 10px;
            width: 100%;
        `,
    },
    signInButton: {
        css: css`
            background: #fc3;
            border: 3px solid #fc3;
            border-radius: 5px;
            color: #000;
            padding: 5px 98px;
            white-space: nowrap;
            font-size: 14px;
            font-weight: 800;
            &:hover {
                background: white;
            }
        `,
    },
    middleBorder: {
        css: css`
            border-bottom: 1px solid #474747;
            margin: 0 auto;
            width: 90%;
        `,
    },
    createAccountContainer: {
        css: css`
            display: flex;
            flex-direction: column;
            justify-content: center;
            margin: 0 auto;
        `,
    },
    createAccountText: {
        css: css`
            color: #000;
            font-size: 16px;
            padding: 10px 0px 0px;
            text-align: center;
        `,
    },
    createAccount: {
        css: css`
            display: flex;
            justify-content: center;
            margin: 0px auto;
            max-width: 250px;
            width: 100%;
        `,
    },
    createAccountButton: {
        css: css`
            background: #474747;
            border: 3px solid #474747;
            border-radius: 5px;
            color: #fff;
            padding: 5px 46px;
            white-space: nowrap;
            font-size: 14px;
            font-weight: 800;
            &:hover {
                background: white;
                color: #000;
            }
        `,
    },
};

interface OwnProps extends WidgetProps {
    fields: {
        [fields.visibilityState]: string;
        [fields.icon]: string;
        [fields.includeAccountMenu]: boolean;
        [fields.showPricingToggle]: boolean;
        [fields.showInventoryToggle]: boolean;
    };
}

type Props = OwnProps &
    ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps> &
    HasHistory &
    ThemeProps<BaseTheme>;

let icon: React.ComponentType<IconPresentationProps>;

export const HeaderSignIn = ({
    userName,
    isSignInPage,
    currentUserIsGuest,
    signOut,
    cancelPunchOut,
    fields,
    history,
    myAccountPageLink,
    signInUrl,
    createAccountUrl,
    isPunchOutSession,
    currentLocation,
    displayChangeCustomerLink,
    displayPricingAndInventory,
    showInventory,
    showPricing,
    setSignInOverlayIsOpen,
    setShowInventory,
    setShowPricing,
    customSession,
    theme,
    isReorderConfirmationModalOpen,
    hasChangeLastQty,
    setIsReorderConfirmationModalOpen,
    setNextAction,
    orderConfirmationPageUrl,
    onePageCheckoutConfirmationPageUrl,
}: Props) => {

    const styles = useMergeStyles("headerSignIn", headerSignInStyles);

    const [isVisible, setIsVisible] = React.useState(false);

    useEffect(() => {
        window.onpageshow = function (event) {
            if (event.persisted) {
                window.location.reload();
            }
        };
    }, [userName]);

    if (!myAccountPageLink) {
        return null;
    }
    
    const { visibilityState, includeAccountMenu, showInventoryToggle, showPricingToggle } = fields;
    const showIcon = visibilityState === "both" || visibilityState === "icon";
    const showLabel = visibilityState === "both" || visibilityState === "label";

    if (fields.icon === "User") {
        icon = User;
    }

    const currentMode = getCookie(NavigationModeCookieName);
    let menuItems = (myAccountPageLink?.children?.filter(
        pageLink => !(pageLink.type === "ChangeCustomerPage" && !displayChangeCustomerLink),
    ) ?? []) as MappedLink[];

    const getMenuItem = (title: "Inventory" | "Pricing"): MappedLink => {
        return {
            title: title === "Inventory" ? translate("Inventory") : translate("Pricing"),
            iconProps: {
                src: (title === "Inventory" && showInventory) || (title === "Pricing" && showPricing) ? EyeOff : Eye,
                size: 22,
                css: css`
                    margin-left: 20px;
                    margin-right: -12px;
                `,
            },
            clickableProps: {
                css: css`
                    display: flex;
                    text-transform: uppercase;
                `,
                onClick: () => {
                    title === "Inventory"
                        ? setShowInventory({ showInventory: !showInventory })
                        : setShowPricing({ showPricing: !showPricing });
                },
            },
        };
    };

    if (!currentMode || currentMode === "Storefront") {
        menuItems = menuItems?.filter(pageLink => pageLink.type !== "VmiUsersPage");

        showInventoryToggle && displayPricingAndInventory && menuItems.push(getMenuItem("Inventory"));
        showPricingToggle && displayPricingAndInventory && menuItems.push(getMenuItem("Pricing"));
    }
    if (isPunchOutSession) {
        if(customSession.userRoles.includes("EnableQuotes")){
            menuItems = menuItems
        .filter(item => item.title === "My Quotes" || item.title === "My Lists")
        .map(item => ({ ...item, excludeFromNavigation: false }));
        }else{
            menuItems = menuItems
        .filter(item => item.title === "My Lists")
        .map(item => ({ ...item, excludeFromNavigation: false }));
        }
    }

    const modalPrevent = (e: MouseEvent) => {
        e.stopPropagation();
    };

    const signHandler = () => {
        setIsVisible(true);
        const addSignIn = () => {
            document.body.removeEventListener("click", addSignIn);
            setIsVisible(false);
        };
        setTimeout(() => {
            document.body.addEventListener("click", addSignIn);
        });
    };

    const onSignInHandler = (e: React.MouseEvent) => {
        if ((!userName || currentUserIsGuest) && !isSignInPage) {
            e.preventDefault();
            // EC-1514 - GTM implementation for navigation_interaction event
            navigationInteraction({
                event: 'navigation_interaction',
                navigation_category: `Header - Sign In`,
                navigation_click: "Sign In",
            })
            e.preventDefault();

            if (theme.signIn?.useOverlay) {
                setSignInOverlayIsOpen({ isOpen: true });
                return;
            }

            if (!signInUrl) {
                logger.warn("No url was found for SignInPage, defaulting to /SignIn");
                history.push("/MyAccount/SignIn");
                return;
            }

            const returnUrl = currentLocation.pathname + currentLocation.search;
            if (
                returnUrl === "/" ||
                (currentUserIsGuest && orderConfirmationPageUrl && returnUrl.indexOf(orderConfirmationPageUrl) > -1) ||
                (currentUserIsGuest &&
                    onePageCheckoutConfirmationPageUrl &&
                    returnUrl.indexOf(onePageCheckoutConfirmationPageUrl) > -1)
            ) {
                history.push(`${signInUrl}`);
                return;
            }

            history.push(`${signInUrl}?
            returnUrl=${encodeURIComponent(returnUrl)}&clientRedirect=true`);
            }
    };

    const onSignOutHandler = () => {
        if (!isReorderConfirmationModalOpen && hasChangeLastQty) {
            setIsReorderConfirmationModalOpen({ isReorderConfirmationModalOpen: true });
            setNextAction({ nextAction: signOutFunc });
        } else {
            signOutFunc();
        }
    };

    const signOutFunc = () => {
        isPunchOutSession ? cancelPunchOut() : signOut();
    };

    let signInStatusText = translate("Sign In");
    if (userName && !currentUserIsGuest) {
        signInStatusText = userName;
    }

    return (
        <StyledWrapper {...styles.signOutWrapper}>
            {fields.includeAccountMenu && userName && !currentUserIsGuest && (
                <Menu
                    descriptionId="accountMenu"
                    menuItems={menuItems}
                    displayChangeCustomerLink={displayChangeCustomerLink}
                    maxDepth={1}
                    menuTrigger={
                        <Clickable {...styles.titleClickable} data-test-selector="header_signIn">
                            {showIcon && <Icon {...styles.titleIcon} src={icon} title={userName} />}
                            {showLabel && (
                                <Typography {...styles.signInTitleTypography} data-test-selector="header_userName">
                                    {userName}
                                </Typography>
                            )}
                        </Clickable>
                    }
                    cssOverrides={{
                        wrapper: css`
                            flex: 0 1 auto;
                            min-width: 0;
                        `,
                    }}
                    data-test-selector="header_accountMenu"
                >
                    {userName && !currentUserIsGuest && (
                        <Clickable
                            {...styles.signOutClickable}
                            onClick={onSignOutHandler}
                            data-test-selector="headerSignOutLink"
                        >
                            {isPunchOutSession ? translate("Cancel PunchOut") : translate("Sign Out")}
                        </Clickable>
                    )}
                </Menu>
            )}
            {(!fields.includeAccountMenu || !userName || (userName && currentUserIsGuest)) && (
                <Clickable
                    {...styles.titleClickable}
                    // onClick={signHandler}
                    onClick={onSignInHandler}
                    href={!signInUrl ? "/MyAccount/SignIn" : signInUrl}
                    data-test-selector="header_signIn"
                >
                    {showIcon && <Icon {...styles.titleIcon} src={icon} title={signInStatusText} />}
                    {showLabel && <Typography {...styles.titleTypography}>{signInStatusText}</Typography>}
                </Clickable>
            )}
            {isVisible && (
                <StyledWrapper {...styles.modalSignIn} onClick={modalPrevent}>
                    <StyledWrapper>{translate("CUSTOMER LOGIN")}</StyledWrapper>

                    <StyledWrapper {...styles.signInButtonContainer}>
                        <Clickable
                            {...styles.signInButton}
                            href={!signInUrl ? "/MyAccount/SignIn" : signInUrl}
                            onClick={() => setIsVisible(false)}
                        >
                            {translate("SIGN IN")}
                        </Clickable>
                    </StyledWrapper>
                    <StyledWrapper {...styles.middleBorder}></StyledWrapper>
                    <StyledWrapper {...styles.createAccountContainer}>
                        <Typography {...styles.createAccountText}>{translate("Don't have an account?")}</Typography>
                    </StyledWrapper>
                    <StyledWrapper {...styles.createAccount}>
                        <Clickable
                            {...styles.createAccountButton}
                            href={!createAccountUrl ? "/MyAccount/CreateAccount" : createAccountUrl}
                            onClick={() => setIsVisible(false)}
                        >
                            {translate("CREATE AN ACCOUNT")}
                        </Clickable>
                    </StyledWrapper>
                </StyledWrapper>
            )}
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(withHistory(withTheme(HeaderSignIn))),
    definition: {
        displayName: "Header Sign In",
        icon: "arrow-right-to-bracket",
        fieldDefinitions: [
            {
                name: fields.visibilityState,
                displayName: "Settings",
                editorTemplate: "RadioButtonsField",
                options: [
                    {
                        displayName: "Both",
                        value: "both",
                    },
                    {
                        displayName: "Show Label",
                        value: "label",
                    },
                    {
                        displayName: "Show Icon",
                        value: "icon",
                    },
                ],
                defaultValue: "both",
                fieldType: "General",
                sortOrder: 1,
            },
            {
                name: fields.icon,
                displayName: "SignIn Icon",
                editorTemplate: "DropDownField",
                options: [
                    {
                        displayName: "User",
                        value: "User",
                    },
                ],
                defaultValue: "User",
                fieldType: "General",
                sortOrder: 2,
            },
            {
                name: fields.includeAccountMenu,
                displayName: "Include My Account Menu",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "General",
                sortOrder: 3,
            },
            {
                name: fields.showPricingToggle,
                displayName: "Show/Hide Pricing Toggle",
                editorTemplate: "CheckboxField",
                isVisible: widget => widget.fields.includeAccountMenu,
                defaultValue: false,
                fieldType: "General",
                sortOrder: 4,
            },
            {
                name: fields.showInventoryToggle,
                displayName: "Show/Hide Inventory Toggle",
                editorTemplate: "CheckboxField",
                isVisible: widget => widget.fields.includeAccountMenu,
                defaultValue: false,
                fieldType: "General",
                sortOrder: 5,
            },
        ],
        group: "Common",
    },
};

export default widgetModule;